import { Trash2 } from 'lucide-react';

import type { CompartilhamentoInfo } from '@/api/client';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';

import type { PeticaoModelo } from './ModelosPage';

interface ModeloShareDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  modelo: PeticaoModelo | null;
  shareEmail: string;
  onShareEmailChange: (value: string) => void;
  onShare: () => Promise<void>;
  sharing: boolean;
  shareList: CompartilhamentoInfo[];
  loadingShares: boolean;
  onRevokeShare: (shareId: string) => Promise<void>;
}

export function ModeloShareDialog({
  open, onOpenChange, modelo,
  shareEmail, onShareEmailChange, onShare, sharing,
  shareList, loadingShares, onRevokeShare,
}: ModeloShareDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Compartilhar Modelo</DialogTitle>
          <DialogDescription>
            Compartilhe <strong>&ldquo;{modelo?.titulo}&rdquo;</strong> com outro usuário do JurisApp.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex gap-2">
            <Input
              type="email"
              placeholder="E-mail do destinatário"
              value={shareEmail}
              onChange={(e) => onShareEmailChange(e.target.value)}
              className="flex-1"
            />
            <Button
              onClick={onShare}
              disabled={sharing || !shareEmail.trim()}
              size="sm"
            >
              {sharing ? 'Enviando...' : 'Compartilhar'}
            </Button>
          </div>
          {loadingShares ? (
            <div className="flex justify-center py-4"><Spinner size={32} /></div>
          ) : shareList.length > 0 ? (
            <div className="space-y-2">
              <p className="text-xs font-medium text-muted-foreground">Compartilhado com:</p>
              {shareList.map((s) => (
                <div key={s.id} className="flex items-center justify-between p-2 rounded border text-sm">
                  <div>
                    <p className="font-medium">{s.compartilhado_com_nome}</p>
                    <p className="text-xs text-muted-foreground">{s.compartilhado_com_email}</p>
                  </div>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-7 w-7 text-destructive"
                    onClick={() => onRevokeShare(s.id)}
                  >
                    <Trash2 className="h-3 w-3" />
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-muted-foreground text-center py-2">
              Modelo ainda não foi compartilhado
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
